import React, { Component } from "react";
import { geolocated } from "react-geolocated";

import { 
    Button,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    CircularProgress
} from '@material-ui/core';

// Icons
import LockIcon from '@material-ui/icons/Lock'

import CanvasDraw from "react-canvas-draw";

import { connect } from 'react-redux';
import PublicIp from 'react-public-ip'
import ModalAlert from '../../components/ModalAlert'
import { detectar_mobile } from '../../utils'
import {
    salvarArquivo,
    limpaMsg,
    enviarEmailSig,
    deslogar
} from '../../actions'

class SignatureScreen extends Component {

    constructor(props) {
        super(props)

        let user = JSON.parse(localStorage.getItem('user'))

        this.state = {
            width: 0, height: 0,
            semAssinatura: false,
            modalToken: false,
            load: false,
            modalGPS: this.props.isGeolocationAvailable ? true : false,
            form: {
                token: user ? user.token : null,
                cpfCnpj: user ? user.cpfCnpj : null,
                categoria: 'assinatura',
                base64file: ''
            },
            email: user ? user.email : null,
            confirm: false,
            semAssinatua: false,
            iniciarValidacaoImagem: false,
            imagemValidada: false,
            widthCanvasMax: 0,
            heightCanvasMax: 0,
            modalDica: detectar_mobile() && window.innerWidth < window.innerHeight ? true : false,
            imagemParaValidar: '',
        }

        this.updateWindowDimensions = this.updateWindowDimensions.bind(this)
        this.inputChange = this.inputChange.bind(this)
    }
    
    async componentDidMount() {
        // if(!localStorage.getItem('user'))
        //     this.props.history.push('/')
        const exigencia = await localStorage.getItem('exigencia')
        if (exigencia) {
            this.setState({ exigencia: JSON.parse(exigencia) })
        }

        await this.updateWindowDimensions()
        window.addEventListener('resize', this.updateWindowDimensions)
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions)
    }
    
    async updateWindowDimensions() {
        var width = window.innerWidth > 1280 ? window.innerWidth * 0.6 : window.innerWidth * 0.8
        this.setState({ width, height: window.innerHeight * 0.8 })

        if (this.state.heightCanvasMax < (width * 0.40)) {
            this.setState({ heightCanvasMax: width * 0.40 });
        }
        if (this.state.widthCanvasMax < (width * 0.75)) {
            this.setState({ widthCanvasMax: width * 0.75 });
        }
    }

    async saveData() {
        this.setState({load: true, confirm: false})
        this.props.limpaMsg()
        const { form } = this.state

        setTimeout(() => {
            var data = document.getElementsByTagName("canvas")[1].toDataURL("image/png")
            document.getElementById('assinatura-confirm').setAttribute('src', data)
            
            this.setState({imagemParaValidar: data});
    
            data = data.replace('data:image/png;base64,', '');
            form['base64file'] = data;

            this.setState({ load: false, iniciarValidacaoImagem: true, form });
            // this.setState({ form })
            // this.salvarArquivo(form)
        }, 2000);  
    }

    clear() {
        this.canvas.clear()
    }

    async validarAssinatura() {
        this.setState({ load: true, imagemValidada: true });

        this.props.limpaMsg();
        const { form } = this.state;

        this.salvarArquivo(form);
    }

    async invalidarAssinatura() {
        this.setState({ load: true, confirm: false, iniciarValidacaoImagem: false, imagemValidada: false, imagemParaValidar: '' });
        this.setState({ heightCanvasMax: ((this.state.width * 0.40 > 180) ? this.state.width * 0.40 : 180) });
        this.setState({ widthCanvasMax: this.state.width * 0.75 });

        this.props.limpaMsg();

        this.setState({ load: false });
    }

    inputChange(e){
        const { form } = this.state
        form[e.target.name] = e.target.value
        this.setState({ form })
    }

    async dataURLtoFile(dataurl, filename) {
 
        var arr = await dataurl.split(','),
            mime = await arr[0].match(/:(.*?);/)[1],
            bstr = await atob(arr[1]), 
            n = bstr.length, 
            u8arr = new Uint8Array(n);
            
        while(n--){
            u8arr[n] = await bstr.charCodeAt(n);
        }
        
        return await new File([u8arr], filename, {type:mime});
    }
      
    async salvarArquivo(form){
        //form.preventDefault()

        var { form, exigencia } = this.state    
        var assinatura = {}
        
        const ip = await PublicIp.v4()
        
        form.ip = ip

        if(this.props.isGeolocationEnabled){
            form.latitude = this.props.coords.latitude
            form.longitude = this.props.coords.longitude
        }
        
        for(let i in form) {
            if( form[i] == '') return alert('Preencha todos os campos!')
            if( i != 'arquivo') assinatura[i] = form[i]
        }

        this.props.salvarArquivo(form, (err) => {
            this.setState({load: false})

            if (!err) {
                if (exigencia.selfie) {
                    this.props.history.push('/selfie');
                } else {
                    localStorage.clear();
                    this.props.history.push('/conclusao');
                }
            }
        })

    }

    async verificarAssinatura(){
        var assinatura = await JSON.parse(this.canvas.getSaveData());
        if (assinatura.lines.length == 0) {
            this.setState({semAssinatura: true});
        } else {
            let quantidadePontos = 0
            assinatura.lines.map((linhaAtual) => {
                quantidadePontos += linhaAtual.points.length
            })
            if (quantidadePontos >= 30) {
                this.setState({ confirm: true })
            } else {
                this.setState({ semAssinatua: true })
            }
        }
    }
      
    render() {
        console.log({state: this.state})
        const { arquivo_load, arquivo_msg, arquivo_error, contatar_load } = this.props.documentos
        const { imagemParaValidar } = this.state
        // const { documento_id, signatario_id } = this.state.form
        const alert = arquivo_error ? 'danger' : 'success' 

        return (
            <Container style={{alignItems: 'center', width: '100%', height:'100%', display:'flex',flexDirection:'column', justifyContent: 'space-between'}}>
                {!this.state.iniciarValidacaoImagem ? <div style={{alignItems: 'center', width: '100%', height:'100%', display:'flex',flexDirection:'column', justifyContent: 'space-between'}}>
                    <CanvasDraw
                        ref={ref => this.canvas = ref}
                
                        style={{borderRadius: '8px', marginTop: this.state.width < this.state.height ? this.state.height * 0.3 : '2%'}}
                        gridColor={'#FFFFFF00'}
                        lazyRadius={0}
                        brushRadius={1}
                        brushColor={"#000"}
                        canvasWidth={this.state.load ? this.state.widthCanvasMax : this.state.width * 0.75}
                        canvasHeight={this.state.load ? this.state.heightCanvasMax : (this.state.width * 0.40 > 180 ? this.state.width * 0.40 : 180)}
                        disabled={this.state.load}
                        id="canvas"
                    />
                    <div style={{position: 'absolute', /*left: '6%',*/ top: '7%', textAlign:'center',display:'flex', alignItems:'center', flexDirection:'column', width:'100%'}}>
                        <h2><b>Assinatura</b></h2>
                        <p style={{ width: '80%'}}>Utilizando o {detectar_mobile() ? 'dedo indicador' : 'mouse'}, por favor desenhe sua assinatura.</p>
                        {detectar_mobile() && this.state.width < this.state.height ? 
                            <small style={{ width: '80%', color: '#787878'}}>Dica: Para uma assinatura melhor, desative o bloqueio de rotação da tela e gire o celular na horizontal e assine.</small>
                            : 
                            null
                        }
                    </div>

                    <div style={{/*position: 'absolute', /*left: '6%',*/ bottom: '5px', width: '100%', display:'flex', flexDirection:'column', justifyContent:'center'}}>
                        {arquivo_error ? 
                            <span style={{ color: 'red', display:'flex', justifyContent:'center' }}>Erro: {arquivo_msg}</span>
                            : null
                        }
                        {this.state.load && <div style={{ display:'flex', justifyContent:'center' }}>
                            <CircularProgress />
                        </div>}

                        {!this.state.load && !this.state.iniciarValidacaoImagem &&
                            <div style={{ display:'flex', alignItems: 'flex-end', width:'100%', justifyContent:'center' }}>
                                <Button style={{ maxHeight: 36 }} className="bg-danger text-light mt-2" variant="contained" onClick={() => this.clear()}>
                                    Limpar
                                </Button>
                                <Button style={{ minHeight: 50, minWidth: 120, fontSize:'x-large', width: '20%' }} className="bg-primary text-light ml-2 mt-2" variant="contained" onClick={() => this.verificarAssinatura()}>
                                    Assinar
                                </Button>
                            </div>
                        }
                    </div>
                    <div></div>
                </div>
                : <div className="canvas-container" style={{alignItems: 'center', width: '100%', height:'100%', display:'flex',flexDirection:'column', justifyContent: 'space-between'}}>
                    <div style={{position: 'absolute', /*left: '6%',*/ top: '7%', textAlign:'center',display:'flex', alignItems:'center', flexDirection:'column', width:'100%'}}>
                        <h2>Verificar Assinatura</h2>
                        {/*!detectar_mobile() &&*/
                        <span>Verifique se sua assinatura está correta.</span>}
                        <p>Por favor, tenha atenção na verificação de sua assinatura.</p>
                    </div>

                    {this.state.imagemParaValidar.length > 0 && <div id="image-sign" 
                        style={{ 
                            backgroundColor: "white", border: "solid 1px", borderRadius: "8px",
                            marginTop: this.state.width < this.state.height ? this.state.height * 0.3 : '2%',
                            width : (this.state.width * 0.75),
                            height: ((this.state.width * 0.40 > 180) ? this.state.width * 0.40 : 180),
                        }} >
                        <img 
                            style={{
                                width: '96%', height: '96%',
                                marginTop: '2%', marginBottom: '2%', marginLeft: '2%', marginRight: '2%'
                            }}
                            src={imagemParaValidar} alt="sign" 
                        />
                    </div>}

                    <div style={{/*position: 'absolute', /*left: '6%',*/ bottom: '5px', width: '100%', display:'flex', flexDirection:'column', justifyContent:'center'}}>
                        {this.state.load && <div style={{ display:'flex', justifyContent:'center' }}>
                            <CircularProgress />
                        </div>}
                        {(arquivo_error || arquivo_error === 'Erro:') ? 
                            <span style={{ color: 'red', display:'flex', justifyContent:'center' }}>Erro: {arquivo_msg}</span>
                            : null
                        }
                        {!this.state.load && this.state.iniciarValidacaoImagem &&
                            <div style={{ display:'flex', alignItems: 'flex-end', width:'100%', justifyContent:'center'}}>
                                <Button style={{ maxHeight: 36 }} className="bg-danger text-light mt-2" variant="contained" variant="contained" onClick={() => this.invalidarAssinatura()}>
                                    Voltar
                                </Button>
                                <Button style={{ minHeight: 50, minWidth: 120, fontSize:'x-large', width: '20%' }} className="bg-primary text-light ml-2 mt-2" variant="contained" onClick={() => this.validarAssinatura()}>
                                    Ficou bom
                                </Button>
                            </div>
                        }
                    </div>
                    <div></div>
                </div>}
                
                {/* MODAL TOKEN */}
                <Dialog
                    open={this.state.modalToken}
                    //TransitionComponent={Transition}
                    keepMounted
                    onClose={() => this.setState({modalToken: false})}
                    fullWidth
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle>
                            <h5 className="modal-title" id="modalSendDoc">Assinar documento  <LockIcon /></h5>
                    </DialogTitle>
                    <form style={{ textAlign: 'left'}} 
                        onSubmit={ (event) => this.salvarArquivo(event)}>
                        <DialogContent>
                            <div style={{textAlign: 'center'}}>
                                <img id='assinatura-confirm' style={{height: '100%', maxHeight: '150px'}} />
                            </div>
                            <div className="form-group" >
                                Enviamos para o seu e-mail um <b>código</b> para autenticar sua assinatura. Por favor insira o código.
                            </div>
                            <div className="form-group">
                                <input placeholder='Informe o código'type="text" className="form-control" name="token" onChange={this.inputChange} 
                                    value={this.state.form.token} required/>

                                {contatar_load
                                    ?<div style={{float:'right',marginRight:'5%',marginTop:'1%'}} className="spinner-border text-primary" role="status"></div>
                                    :null
                                    /* <div className="form-group">
                                        <span style={{float:'right',marginTop:'1%',cursor:'pointer'}} 
                                            className="btn btn-outline-primary btn-sm"
                                            onClick={ () => this.props.enviarEmailSig(documento_id,signatario_id)}>Reenviar token</span>
                                    </div> */
                                }
                            </div>
                            {arquivo_msg != ''?
                                <div className={`alert alert-${alert}`} role="alert">
                                    {arquivo_msg}
                                </div>
                                : null
                            }
                        </DialogContent>
                        <DialogActions>
                            <div className="form-group">
                                {arquivo_load?
                                    <CircularProgress />
                                    :
                                    <div>
                                        <Button onClick={() => this.setState({ modalToken: false })} disabled={contatar_load}>Cancelar</Button>
                                        <Button type="submit" variant="contained" style={{backgroundColor: '#28a745', color: 'white'}} disabled={contatar_load}>Enviar</Button>
                                    </div>
                                }                                        
                            </div>
                            
                        </DialogActions>
                    </form>   
                </Dialog>
                {/* MODAL CONCLUSÃO */}
                <Dialog
                    open={this.state.modalGPS}
                    //TransitionComponent={Transition}
                    keepMounted
                    fullWidth
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogContent>
                        <div style={{textAlign: 'center'}}>
                            <h2>Permitir localização</h2>
                            <h5> 
                                Para continuar, por favor clique em permitir localização
                            </h5>
                            <div>
                                <div>
                                    Imagem de exemplo
                                </div>
                                <img src="/assets/imagem/geo-exemplo.png" alt="" style={{height: '50px', marginBottom: '2em'}} />
                            </div>
                            {this.props.isGeolocationEnabled == false ?
                                <div className={`alert alert-danger`} role="alert">
                                    Geolocalização desativada
                                </div>
                                :
                                null
                            }
                                <Button variant="contained" style={{backgroundColor: '#28a745', color: 'white'}} onClick={ () => this.setState({modalGPS: false})}>
                                    Ok, entendi
                                </Button>
                        </div>
                    </DialogContent>
                </Dialog>
                
                <ModalAlert
                    open={this.state.confirm}
                    handleClose={ () => this.setState({ confirm: false })}
                    action={ () => this.saveData()}
                    text="Ao clicar em continuar você estará declarando que está de acordo com os termos e condições do contrato"
                    title="Atenção!"
                    buttonClose="CANCELAR"
                    buttonAccept="CONTINUAR"
                />
                <Dialog
                    open={this.state.semAssinatura}
                    //TransitionComponent={Transition}
                    keepMounted
                    fullWidth
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogContent>
                        <div style={{textAlign: 'center'}}>
                            <h5> 
                                Assinatura não identificada. Por favor, utilize o {detectar_mobile() ? 'dedo indicador' : 'mouse'} para assinar.
                            </h5>
                            <Button variant="contained" style={{backgroundColor: '#28a745', color: 'white'}} onClick={ () => this.setState({semAssinatura: false})}>
                                Ok, entendi
                            </Button>
                        </div>
                    </DialogContent>
                </Dialog>
            <style>
                {
                    `#root{ background: #dfdfdf;}
                    .box-container {
                        width: 95%;
                    }
                    .box-content {
                        padding-bottom: 48%;   
                    }
                    `
                }
            </style>
            </Container>
        )
    }
}

const mapStateToProps = ({ documentos }) => {
    return {
        documentos
    }
}

export default geolocated({
    positionOptions: {
        enableHighAccuracy: false,
    },
    userDecisionTimeout: 5000,
})(connect(mapStateToProps, {
    salvarArquivo,
    limpaMsg,
    enviarEmailSig,
    deslogar
})(SignatureScreen));